// context/AppContext.js
import React, { createContext, useState, useEffect, useMemo } from 'react';
import { getDataDB, saveDataDB, modifyDataModel } from "./api";
import useLocalStorage from "use-local-storage";
import Cookies from 'js-cookie';

export const AppContext = createContext();
export const defaultSiteName = "banking-v1";


// const addMissingProps = async ({ source, target }) => {
//   // Helper function to determine if a value is an object
//   const isObject = (obj) => obj && typeof obj === 'object';

//   // If source is not an object or is null, return the target as is
//   if (!isObject(source)) return target;
//   // If target is not an object or is null, return a shallow copy of the source
//   if (!isObject(target)) return { ...source };

//   // Initialize the result as a shallow copy of the target
//   const result = Array.isArray(target) ? [...target] : { ...target };

//   // Iterate over each key in the source object
//   for (const key in source) {
//     if (Object.prototype.hasOwnProperty.call(source, key)) {
//       // If the key doesn't exist in the result, add it from the source
//       if (!(key in result)) {
//         result[key] = source[key];
//       } else if (isObject(source[key]) && isObject(result[key])) {
//         // If both source and result have the same key and the values are objects,
//         // recursively merge them
//         result[key] = await addMissingProps({ source: source[key], target: result[key] });
//       }
//       // If the key exists in both but the values are not both objects, retain the target's value
//     }
//   }

//   return result;
// };


export const addMissingProps = async ({ source, target }) => {
  const isObject = (obj) => obj && typeof obj === 'object' && !Array.isArray(obj);

  if (!isObject(source)) return target;
  if (!isObject(target)) return { ...source };

  const result = { ...target };

  for (const key in source) {
    if (!Object.prototype.hasOwnProperty.call(source, key)) continue;

    const sourceVal = source[key];
    const targetVal = result[key];

    if (!(key in result)) {
      // ✅ Add key from source only if it doesn't exist in target
      result[key] = sourceVal;
    } else if (isObject(sourceVal) && isObject(targetVal)) {
      // ✅ Recursively merge nested objects without replacing target
      result[key] = await addMissingProps({ source: sourceVal, target: targetVal });
    }
    // ❌ Do not override primitives or arrays — target takes precedence
  }

  return result;
};


export const AppProvider = ({ children }) => {
  const [appState, setAppState] = useState({
    user: null,
    theme: "light",
    editMode: false,
  });
  const [myStore, setMyStore] = useLocalStorage("name", {});
  // const {
  //   myInfo = {
  //     handle: "@gamming",
  //     name: "Admin",
  //     fullName: "Admin",
  //     siteName: "banking-v1"
  //   }
  // } = myStore
  const cookieInfo = Cookies.get('myInfo');

  const myInfo = cookieInfo ? JSON.parse(cookieInfo) : {
    handle: "@gamming",
    name: "Admin",
    fullName: "Admin",
    siteName: "banking-v1"
  };

  const {
    siteName = "banking-v1"
  } = myInfo


  useEffect(() => {
    if (cookieInfo) {
      const parsed = JSON.parse(cookieInfo);
      setMyStore(prev => ({
        ...prev,
        myInfo: parsed
      }));
    }
  }, [cookieInfo]);

  const [myContext, setMyContext] = useState({
    myInfo: {
      handle: "@gamming",
      name: "Admin",
      fullName: "Admin",
      siteName: "banking-v1"
    },
  });



  const [myConfig, setMyConfig] = useState({})

  useEffect(() => {
    (async () => {

      return siteName && await getDataDB({
        query: {
          siteName: siteName || 'banking-v1',
        },
        resource: "vare_banking_site",
      }).then((infoTemp) => {
        // console.log('xxccccc', appState)
        const info = infoTemp?.filter(res => res.siteName == siteName)

        if (info?.[0]?.config) {
          setMyConfig({
            // configVersions: info?.[0]?.configVersions,
            ...info?.[0]?.config
          })
          // console.log('xxccccc', info?.[0]?.configVersions)
        }
      });
    })()

  }, [
    // appState,
    siteName
  ])

  useEffect(() => {
    (async () => {
      if (siteName) {
        // alert(siteName)
        await getDataDB({
          query: {
            siteName: siteName || 'banking-v1',
          },
          resource: "vare_banking_site",
        }).then((infoTemp) => {
          // console.log('xxccccc', appState)
          const info = infoTemp?.filter(res => res.siteName == siteName)

          if (info?.[0]?.config) {
            setMyConfig({
              // configVersions: info?.[0]?.configVersions,
              ...info?.[0]?.config
            })
            // console.log('xxccccc', info?.[0]?.configVersions)
          }
        });
      }
    })()

  }, [
    // appState,
    siteName
  ])

  const result = useMemo(() => {

    const report = {
      ...appState,
      siteName: "banking-v1",
      header: {
        emails: 'modupe@varetechnologies.com,dipoty0@gmail.com,info@heritagehubfederal.org',
        address: '9000 Regency Parkway, Suite 400 Cary',
        languages: [
          { label: 'English' },
          { label: 'Spanish' }
        ],
        socialLinks: [
          { icon: 'fab fa-facebook-f', url: '#' },
          { icon: 'fab fa-twitter', url: '#' },
          { icon: 'fab fa-linkedin', url: '#' },
          { icon: 'fab fa-youtube', url: '#' },
        ],
        img: "https://varefiles.s3.us-east-2.amazonaws.com/Heritage+hub+Logo-white.png",
        width: "50",
        logo: "https://varefiles.s3.us-east-2.amazonaws.com/Heritage+hub+Logo-white.png",
        navigationmenu: [
          {
            "id": 1,
            "linkText": "Home",
            "child": true,
            "link": "/",
            "submenu": [
              {
                "id": 11,
                "link": "#aboutus",
                "linkText": "About Us"
              },
              // {
              //   "id": 11,
              //   "link": "/",
              //   "linkText": "Homepage 1"
              // },
              // {
              //   "id": 12,
              //   "link": "/home-v2",
              //   "linkText": "Homepage 2"
              // }
            ]
          },
          {
            "id": 2,
            "linkText": "Finance",
            "link": "/finance",
            "child": true,
            "submenu": [
              {
                "id": 51,
                "link": "/",
                "linkText": "TBD"
              },
            ]
          },
          // {
          //   "id": 3,
          //   "linkText": "Blog",
          //   "child": false,
          //   "link": "/",
          //   "submenu": [
          //     {
          //       "id": 31,
          //       "link": "/blog",
          //       "linkText": "Blog Grid"
          //     },
          //     {
          //       "id": 32,
          //       "link": "/blog-sidebar",
          //       "linkText": "Blog Left"
          //     },
          //     {
          //       "id": 33,
          //       "link": "/blog-single/1",
          //       "linkText": "Blog Details"
          //     }
          //   ]
          // },
          // {
          //   "id": 4,
          //   "linkText": "Pages",
          //   "child": true,
          //   "link": "/",
          //   "submenu": [
          //     {
          //       "id": 41,
          //       "link": "/error",
          //       "linkText": "404"
          //     },
          //     {
          //       "id": 42,
          //       "link": "/coming-soon",
          //       "linkText": "Coming Soon"
          //     },
          //     {
          //       "id": 43,
          //       "link": "/team",
          //       "linkText": "Our Team"
          //     },
          //     {
          //       "id": 44,
          //       "link": "/loan-calculator",
          //       "linkText": "Loan Calculator"
          //     },
          //     {
          //       "id": 45,
          //       "link": "/about",
          //       "linkText": "About Us"
          //     },
          //     {
          //       "id": 46,
          //       "link": "/contact",
          //       "linkText": "Contact Us"
          //     }
          //   ]
          // },
          {
            "id": 5,
            "linkText": "Services",
            "child": false,
            "link": "#services",
            "submenu": [
              {
                "id": 51,
                "link": "/",
                "linkText": "TBD"
              },
              // {
              //   "id": 51,
              //   "link": "/service",
              //   "linkText": "Service"
              // },
              // {
              //   "id": 52,
              //   "link": "/service-detail/1",
              //   "linkText": "Service Detail"
              // }
            ]
          },
          {
            "id": 6,
            "linkText": "User Dashboard",
            "link": "/loan-dashboard",
          }
        ]
      },
      banner: {
        title: 'HeritageHub',
        video: "https://varefiles.s3.us-east-2.amazonaws.com/hh-banking-video-compress.mp4",
        banner: [
          {
            title: "Affordable Loans Made Easy",
            text: "Quick approvals, low rates, and simple applications.",
            buttonText: 'Explore',
            "link": "/finance",
          },
          {
            title: "Finance Your Future",
            text: "We support your goals with flexible loan options.",
            buttonText: 'Explore',
            "link": "/finance",
          }
        ]
      },
      intro: {
        items: [
          {
            title: "CORPORATE LOAN",
            text: "Create pages with ease with a help of the best page builder plugin.",
            resClass: "mb-md-20",
            buttonText: 'Read more',
            "link": "/finance",
            rate: "35%",
            metric: "APR",
            icon: "item.icon"
          },
          {
            title: "GET FUNDS IN SECOND",
            text: "Create pages with ease with a help of the best page builder plugin.",
            resClass: "mb-md-20",
            buttonText: 'Read more',
            "link": "/finance",
            rate: "35%",
            metric: "APR",
            icon: "item.icon"
          },
          {
            title: "REPAY AS YOU GET PAID",
            text: "Create pages with ease with a help of the best page builder plugin.",
            resClass: "mb-xs-20",
            buttonText: 'Read more',
            "link": "/finance",
            rate: "35%",
            metric: "APR",
            icon: "item.icon"
          },
          {
            title: "ONE FIX FEE",
            text: "Create pages with ease with a help of the best page builder plugin.",
            resClass: "",
            buttonText: 'Read more',
            "link": "/finance",
            rate: "35%",
            metric: "APR",
            icon: "item.icon"
          }
        ]
      },
      aboutus: {
        title: 'HeritageHub',
        heading: "Not Fast Decision But Good Decision Fast.",
        description: `Our menu is a nod to street food vendors who help their customers stay on-the-go by delivering quick tasty bites. We incorporated flavors from around the world to offer a unique menu featuring items like Banh Mi, a flavorful sandwich staple from Vietnam, and the classic American Burger.`,
        list: [
          { label: "Fast Loan", value: true }, { label: "Less Fee", value: true }, { label: "Less Paperwork", value: true }, { label: "Less Interest", value: true }],
        author: {
          name: "Bola H",
          title: "Founder of Credit Union",
          image: "/assets/images/signature.png"
        },
        images: {
          image: "/assets/images/homepage/about2.jpg",
          img: "/assets/images/homepage/about1.jpg"
        }
      },
      services: {
        title: 'HeritageHub',
        header: "Our Services",
        buttonHeaderText: 'View More',
        "link": "/finance",
        description:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.",
        items: [
          {
            id: 1,
            icon: "flaticon-loan",
            title: "Personal Loan",
            shortdesc: "Short-term personal loans with flexible rates.",
            "link": "/finance",

          },
          {
            id: 2,
            icon: "flaticon-car",
            title: "Auto Loan",
            shortdesc: "Finance your car with our quick approval auto loans.",
            "link": "/finance",

          },
          {
            id: 3,
            icon: "flaticon-home",
            title: "Home Loan",
            shortdesc: "Affordable home loans with low interest rates.",
            "link": "/finance",

          },
          {
            id: 4,
            icon: "flaticon-credit-card",
            title: "Credit Services",
            shortdesc: "Credit rebuilding and management plans.",
            "link": "/finance",
          }
        ]
      },
      loancalculator: {
        title: "Customize your loan",
        subtitle: "Adjust the loan amount to see your options",
        rangeNote: "You can borrow between",
        borrowMin: "1000",
        borrowMax: "50000",
        plans: [
          {
            id: "loanstep1",
            percent: 30,
            fee: "$1,672",
            total: "$43,000",
            time: "12 Months",
            upperText: "Repay With One-Time Fee",
            "link": "/finance",

          },
          {
            id: "loanstep2",
            percent: "25",
            fee: "$2,027",
            total: "$43,000",
            time: "12 Months",
            upperText: "Repay With One-Time Fee",
            "link": "/finance",

          },
          {
            id: "loanstep3",
            percent: "20",
            fee: "$2,749",
            total: "$43,000",
            time: "12 Months",
            upperText: "Repay With One-Time Fee",
            "link": "/finance",

          },
          {
            id: "loanstep4",
            percent: "15",
            fee: "$4,080",
            total: "$43,000",
            time: "12 Months",
            upperText: "Repay With One-Time Fee",
            "link": "/finance",

          },
          {
            id: "loanstep5",
            percent: "10",
            fee: "$7,394",
            total: "$43,000",
            time: "12 Months",
            upperText: "Repay With One-Time Fee",
            "link": "/finance",

          }
        ]
      },

      advertisement: {
        subtext: "Fast Approval - Less Fee",
        heading: "We are with you every step.",
        buttons: [
          { label: "Our Services", link: "/#service", variant: "btn-submit" },
          { label: "Start Now", link: "/#contact", variant: "btn-submit-fill" }
        ]
      },
      team: {
        title: "Our Teams",
        description:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.",
        members: [
          {
            "id": 1,
            "photo": "assets/images/doctors/doctor3.jpg",
            "name": "Eachann Jhon",
            "designation": "Loan Advisor",
            "socialmedia": [
              {
                "icon": "youtube",
                "iconclass": "youtube",
                "url": "#"
              },
              {
                "icon": "linkedin",
                "iconclass": "linkedin",
                "url": "#"
              },
              {
                "icon": "facebook-f",
                "iconclass": "facebook",
                "url": "#"
              },
              {
                "icon": "twitter",
                "iconclass": "twitter",
                "url": "#"
              }
            ]
          },
          {
            "id": 2,
            "photo": "assets/images/doctors/doctor2.jpg",
            "name": "Addison Smith",
            "designation": "Business Loan Advisor",
            "socialmedia": [
              {
                "icon": "youtube",
                "iconclass": "youtube",
                "url": "#"
              },
              {
                "icon": "linkedin",
                "iconclass": "linkedin",
                "url": "#"
              },
              {
                "icon": "facebook-f",
                "iconclass": "facebook",
                "url": "#"
              },
              {
                "icon": "twitter",
                "iconclass": "twitter",
                "url": "#"
              }
            ]
          },
          {
            "id": 3,
            "photo": "assets/images/doctors/doctor4.jpg",
            "name": "Sarah Taylor",
            "designation": "Loan Advisor",
            "socialmedia": [
              {
                "icon": "youtube",
                "iconclass": "youtube",
                "url": "#"
              },
              {
                "icon": "linkedin",
                "iconclass": "linkedin",
                "url": "#"
              },
              {
                "icon": "facebook-f",
                "iconclass": "facebook",
                "url": "#"
              },
              {
                "icon": "twitter",
                "iconclass": "twitter",
                "url": "#"
              }
            ]
          },
          {
            "id": 4,
            "photo": "assets/images/doctors/doctor5.jpg",
            "name": "Aiken Ward",
            "designation": "Corporate Loan Advisor",
            "socialmedia": [
              {
                "icon": "youtube",
                "iconclass": "youtube",
                "url": "#"
              },
              {
                "icon": "linkedin",
                "iconclass": "linkedin",
                "url": "#"
              },
              {
                "icon": "facebook-f",
                "iconclass": "facebook",
                "url": "#"
              },
              {
                "icon": "twitter",
                "iconclass": "twitter",
                "url": "#"
              }
            ]
          },
          {
            "id": 5,
            "photo": "assets/images/doctors/doctor3.jpg",
            "name": "Babatunde jhon",
            "designation": "Home Loan Advisor",
            "socialmedia": [
              {
                "icon": "youtube",
                "iconclass": "youtube",
                "url": "#"
              },
              {
                "icon": "linkedin",
                "iconclass": "linkedin",
                "url": "#"
              },
              {
                "icon": "facebook-f",
                "iconclass": "facebook",
                "url": "#"
              },
              {
                "icon": "twitter",
                "iconclass": "twitter",
                "url": "#"
              }
            ]
          }
        ]
      },
      bookappointment: {
        left: [
          {
            heading: "Make an Appointment",
            description: "We look forward to serving you. Fill out the form or contact us directly.",
            subheading: "We're here to help",
            address: "123 Main St, Cityville, USA",
            email: "contact@loanly.com",
            phone: "(123) 456-7890"
          }
        ],
        right: [
          {
            heading: "Book Now",
            form: [
              {
                key: "name",
                label: "Full Name",
                icon: "fa-user"
              },
              {
                key: "email",
                label: "Email Address",
                type: 'text',
                icon: "fa-envelope",
                type: "email"
              },
              {
                key: "phone",
                label: "Phone Number",
                type: 'phone',
                icon: "fa-phone-alt"
              }
              // {
              //   key: "availableDate",
              //   label: "Available Date",
              //   type: 'date',
              //   icon: "fa-phone-alt"
              // }
              // {
              //   key: "button",
              //   label: "Submit"
              // }
            ]
          }
        ]
      },
      testimonials: {
        sectionTitle: "Our Testimonials",
        sectionDescription: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.",
        clientTitle: "Our Clients",
        clientDescription: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.",
        items: [
          {
            title: "Excellent Service",
            comment: "Fast, professional, and transparent process.",
            name: "Sarah Taylor",
            designation: "Marketing Lead",
            image: "assets/images/users/user1.jpg"
          },
          {
            title: "Trusted Partner",
            comment: "We’ve worked with them for years. Always reliable!",
            name: "Addison Smith",
            designation: "CEO, StartupHub",
            image: "assets/images/users/user2.jpg"
          }
        ],
        clients: [
          { companyname: "TechNova", image: "assets/images/clients/client1.png" },
          { companyname: "FinCore", image: "assets/images/clients/client2.png" }
        ]
      },
      faqs: {
        // title: "Compare personal loan rates in 2 minutes",
        // placeholder: "Enter amount ($1,000 to $100,000)",
        // button: "Find My Rate",
        section: {
          heading: "Our FAQs",
          subtext: "Still have questions? Our Client Success Team is always here to help"
        },
        support: {
          image: "/assets/images/faq-user.png",
          email: "Support@domain.com",
          phone: "123-456-7890",
          chat: "Chat with us",
          schedule: [
            { day: "Mon - Thurs", time: "6am – 6pm PT" },
            { day: "Fri", time: "6am – 6pm PT" },
            { day: "Sat - Sun", time: "7am – 4pm PT" }
          ]
        },
        items: [
          {
            question: "What is an unsecured personal loan?",
            answer: [
              { label: "Once approved for an unsecured loan, you'll make monthly payments to pay it back in full, plus interest." },
              { label: "Each lender has their own set requirements to qualify for a personal loan." }
            ]
          },
          {
            question: "What are the requirements to qualify?",
            answer: [
              { label: "Each lender has their own set requirements to qualify for a personal loan." }
            ]
          },
          {
            question: "How much can I borrow with a personal loan?",
            answer: [
              { label: "Many lenders also have minimum credit score requirements." },
              { label: "The upper limits for personal loans vary but usually fall in the $35,000 to $50,000 range." }
            ]
          }
          // ...additional FAQ items
        ]
      },
      contactus: {
        heading: 'Contact Us',
        subtext: "Still have questions? Our Client Success Team is always here to help",
        header: "Get In Touch",
        details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
        content: [
          {
            icon: "fas fa-phone-alt",
            title: "Phone",
            text: "Start working with LOANLY that can provide everything",
            info: "+(347)123 456 7890",
          },
          {
            icon: "far fa-envelope",
            title: "Email",
            text: "Start working with LOANLY that can provide everything",
            info: "contact@example.com",
          },
          {
            icon: "fas fa-map-marker-alt",
            title: "Location",
            text: "Start working with LOANLY that can provide everything",
            info: "View on Google map",
          },
        ],
        formFields: [
          { name: "name", label: "Full Name", type: "text", placeholder: "Full Name" },
          { name: "email", label: "Email Address", type: "email", placeholder: "Email Address" },
          { name: "phone", label: "Phone No.", type: "text", placeholder: "Phone No." },
          { name: "subject", label: "Subject", type: "text", placeholder: "Subject" },
          { name: "message", label: "Message", type: "textarea", placeholder: "Write Something" },
        ],
        success: "Success! Contact form has been successfully submitted.",
        errorMessage: "Oops!</strong> Something bad happened. Please try again later"
      },
      footer: {
        links: [
          { label: "About Us", to: "#aboutus" },
          { label: "Service", to: "#services" },
          // { label: "Blog", to: "/blog" },
          { label: "Team", to: "#team" },
          { label: "Contact Us", to: "#contactus" }
        ],
        locations: [
          {
            id: 1,
            address: "2645 Winrock Blvd",
            postcode: "Houston, TX 77057",
            image: "assets/images/blog/blog1.jpg"
          },
          {
            id: 2,
            address: "2645 Winrock Blvd",
            postcode: "Houston, TX 77057",
            image: "assets/images/blog/blog2.jpg"
          }
        ],
        banners: [
          {
            id: 1,
            message: "let us serve you",
            postcode: "Houston, TX 77057",
            image: "assets/images/blog/blog1.jpg"
          },
          // {
          //   id: 2,
          //   message: "let us serve you",
          //   postcode: "Houston, TX 77057",
          //   image: "assets/images/blog/blog2.jpg"
          // }
        ],
        // tweets: [
        //   {
        //     tweet: "Check out our latest blog post on loan tips!",
        //     link: "#",
        //     tweetdate: "April 1, 2025"
        //   },
        //   {
        //     tweet: "We’re now open on weekends!",
        //     link: "#",
        //     tweetdate: "March 25, 2025"
        //   }
        // ],
        // newsletter: {
        //   placeholder: "Email Id",
        //   button: "Subscribe"
        // },
        socials: [
          { label: "facebook-f" }, { label: "twitter" }, { label: "instagram" }, { label: "youtube" }, { label: "google-plus" }],
        copyright: {
          text: "© Vare Technology - 2025 | All Right Reserved.",
          credit: "Designed By Vare Technology"
        },
        image: "/assets/images/footer-bottom-img.png"
      },
      finance: {
        title: 'Finance',
        header: 'Home',
        subHeader: 'Finance',
        image: "https://varefiles.s3.us-east-2.amazonaws.com/meetingpic2.jpg"
      },
      stepOne: {
        title: 'Step One',
        formConfig: [
          {
            name: 'businessName',
            label: 'Business Name',
            type: 'text',
            placeholder: 'Business Name',
            col: 'col-12',
          },
          {
            name: 'firstName',
            label: 'First Name',
            type: 'text',
            placeholder: 'First Name',
            col: 'col-md-6',
          },
          {
            name: 'lastName',
            label: 'Last Name',
            type: 'text',
            placeholder: 'Last Name',
            col: 'col-md-6',
          },
          {
            name: 'phone',
            label: 'Phone No.',
            type: 'text',
            placeholder: 'Phone No.',
            col: 'col-md-6',
          },
          {
            name: 'email',
            label: 'Email Address',
            type: 'email',
            placeholder: 'Email Address',
            col: 'col-md-6',
          },
          {
            name: 'phoneType',
            label: 'Phone Type',
            type: 'radio',
            options: ['Business', 'Mobile', 'Home'],
            col: 'col-12',
          },
          {
            name: 'loanPurpose',
            label: 'Primary Loan Purpose',
            type: 'select',
            options: ['Purchase business location', 'Option 2', 'Option 3', 'Option 4', 'Option 5'],
            col: 'col-lg-6',
          },
          {
            name: 'reference',
            label: 'Reference',
            type: 'select',
            options: ['Banner/Digital Ad', 'Option 2', 'Option 3', 'Option 4', 'Option 5'],
            col: 'col-lg-6',
          },
          {
            name: 'agree',
            label: 'I Agree to the terms & conditions and privacy policy.',
            type: 'checkbox',
            col: 'col-12',
          }
        ]
      },
      stepTwo: {
        title: 'Step Two',
        formConfig: [
          {
            name: 'homeAddress1',
            label: 'Home Address 1',
            type: 'text',
            placeholder: 'Home Address 1',
            col: 'col-lg-6',
          },
          {
            name: 'homeAddress2',
            label: 'Home Address 2 (Optional)',
            type: 'text',
            placeholder: 'Home Address 2 (Optional)',
            col: 'col-lg-6',
          },
          {
            name: 'city',
            label: 'City',
            type: 'text',
            placeholder: 'City',
            col: 'col-lg-4',
          },
          {
            name: 'state',
            label: 'State',
            type: 'select',
            options: ['NY', 'Option 2', 'Option 3', 'Option 4', 'Option 5'],
            col: 'col-lg-4',
          },
          {
            name: 'zip',
            label: 'ZIP',
            type: 'text',
            placeholder: 'ZIP Code',
            col: 'col-lg-4',
          },
          {
            name: 'mobilePhone',
            label: 'Mobile Phone No.',
            type: 'text',
            placeholder: 'Mobile Phone No.',
            col: 'col-md-6',
          },
          {
            name: 'homePhone',
            label: 'Home Phone No.',
            type: 'text',
            placeholder: 'Home Phone No.',
            col: 'col-md-6',
          }
        ]
      },
      stepThree: {
        title: 'Step Three',
        formConfig: [
          {
            name: 'businessAddress1',
            label: 'Business Address 1',
            type: 'text',
            placeholder: 'Business Address 1',
            col: 'col-lg-6',
          },
          {
            name: 'businessAddress2',
            label: 'Business Address 2 (Optional)',
            type: 'text',
            placeholder: 'Business Address 2 (Optional)',
            col: 'col-lg-6',
          },
          {
            name: 'city',
            label: 'City',
            type: 'text',
            placeholder: 'City',
            col: 'col-lg-4',
          },
          {
            name: 'state',
            label: 'State',
            type: 'select',
            options: ['NY', 'Option 2', 'Option 3', 'Option 4', 'Option 5'],
            col: 'col-lg-4',
          },
          {
            name: 'zip',
            label: 'ZIP',
            type: 'text',
            placeholder: 'ZIP Code',
            col: 'col-lg-4',
          },
          {
            name: 'businessPhone',
            label: 'Business Phone No.',
            type: 'text',
            placeholder: 'Business Phone No.',
            col: 'col-12',
          },
        ]
      },
      stepFour: {
        title: 'Step Four',
        formConfig: [
          {
            name: 'businessType',
            label: 'Business Entry type',
            type: 'select',
            options: ['Sol Proprietorship', 'Option 2', 'Option 3', 'Option 4', 'Option 5'],
            col: 'col-12',
          },
          {
            name: 'annualRevenue',
            label: 'Total annual business revenue',
            type: 'text',
            placeholder: '$ 10,000.00',
            col: 'col-lg-6',
          },
          {
            name: 'fullTimeEmployees',
            label: 'Number of full time employees',
            type: 'text',
            placeholder: '1',
            col: 'col-lg-6',
          },
          {
            name: 'businessIndustry',
            label: 'Business Industry',
            type: 'select',
            options: [
              'Professional and Technical Services',
              'Option 2',
              'Option 3',
              'Option 4',
              'Option 5',
            ],
            col: 'col-12',
          },
          {
            name: 'businessSubIndustry',
            label: 'Business Sub-industry',
            type: 'select',
            options: [
              'Advertising Agencies and all other related services',
              'Option 2',
              'Option 3',
              'Option 4',
              'Option 5',
            ],
            col: 'col-12',
          },
        ]
      },
      stepFive: {
        title: 'Step Five',
        formConfig: [
          {
            name: 'dateOfBirth',
            label: 'Date of Birth',
            type: 'date',
            placeholder: '01/01/1990',
            col: 'col-lg-6',
          },
          {
            name: 'ssn',
            label: 'Social Security Number',
            type: 'text',
            placeholder: 'Social Security Number',
            col: 'col-lg-6',
          },
          {
            name: 'taxId',
            label: 'Federal Tax ID',
            type: 'text',
            placeholder: 'Federal Tax ID',
            col: 'col-12',
            description:
              'Enter your social security number (SSN) if your business is a sole proprietorship or single-owner LLC without a Federal Tax ID.',
          },
          {
            name: 'citizenship',
            label: 'Are you a citizen or permanent resident of the U.S.?',
            type: 'radio',
            options: ['Yes', 'No'],
            col: 'col-12',
          },
          {
            name: 'agreeDisclosure',
            label:
              'I agree to receive Loan disclosures electronically to any email address provided by me.',
            type: 'checkbox',
            col: 'col-12',
          },
          {
            name: 'agreeTerms',
            label:
              'I understand that by clicking the “Submit” button below, that I am giving Loanly, LLC and Loanly written instructions under the Fair Credit Reporting Act to obtain my personal and business credit reports and to evaluate my eligibility. Answering these questions lets me check my price and will not impact my credit score. I understand that if I sign a loan agreement, Loanly, LLC and Loanly will not perform credit checks and other public records checks, which may impact my credit score.',
            type: 'checkbox',
            col: 'col-12',
          },
        ]
      },
      dashboard: {
        companyUrl: "www.companyname.com",
        loanProfileLabel: "Your Loan Profile",
        welcomeTitle: "Welcome Back!",
        welcomeMessage: "We're happy to help you grow your business with Loanly Working Capital.",
        viewHistoryLabel: "View loan history",
        stat: [
          {
            label: "Loans",
            value: 5,
            extraLabel: "",
            extraValue: ""
          },
          {
            label: "Total Borrowed",
            value: "$ 50,000",
            extraLabel: "",
            extraValue: ""
          },
          {
            label: "Last Payment on",
            value: "24th April 20",
            extraLabel: "View",
            extraValue: "details"
          }
        ],
        detailsLinks: [
          { label: "View Monthly Details" },
          { label: "View Yearly Details" }
        ],
        iconFeatures: [
          { icon: "/assets/images/more.png", text: "Get more out of Loanly" },
          { icon: "/assets/images/connect.png", text: "Connect with the best" },
          { icon: "/assets/images/move.png", text: "Plan your next move" }
        ]
      },
      login: {
        loginTitle: "Sign In to Your Account",
        registerTitle: "Create a New Account",

        emailLabel: "Email Address",
        passwordLabel: "Password",
        confirmPasswordLabel: "Confirm Password",
        nameLabel: "Full Name",

        loginButton: "Login",
        registerButton: "Register",

        noAccountText: "Don't have an account?",
        registerNowText: "Register Now",

        haveAccountText: "Already registered?",
        loginNowText: "Login Here",

        rememberMeLabel: "Remember Me",
        forgotPasswordText: "Forgot Password?",

        successLoginMessage: "Login Successful!",
        successRegisterMessage: "Registration Successful!",
        errorLoginMessage: "Invalid email or password",
        errorRegisterMessage: "Please check your information and try again"
      }




    }

    return report

  }, [

  ]);

  useEffect(() => {

    (async () => {
      const info = await addMissingProps({
        source: result,
        target: myConfig
      })
      // console.log('cccccc', info)

      setAppState(
        {
          myorder: [
            "header",
            "banner",
            "intro",
            "aboutus",
            "services",
            "loancalculator",
            "advertisement",
            "team",
            "bookappointment",
            "testimonials",
            "faqs",
            "contactus",
            "dashboard",
            "login",
            "finance",
            "footer",
          ],
          ...info,
          editItemMain: {},
          defaultConfig: result,
          section: "",
        }
      );

    })()


  }, [
    result,
    myConfig
  ]);

  return (
    <AppContext.Provider value={{
      appState, setAppState,
      myContext, setMyContext
    }}>
      {children}
    </AppContext.Provider>
  );
};
